import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import { Button, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../../api";

class Notificacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Nombre:'',
            title:'',
            notification : {
                body:'',
                title:'',
            },
            errors: [],
        };
    }

    static propTypes = {
        row: PropTypes.func,
        onSubmit: PropTypes.func,
        id: PropTypes.func,
    }

    resetForm() {
        this.setState({
            Nombre:'',
            notification : {
                body:'',
                title:'',
            },
            errors: [],
        });
    }

    getData() {
        return {notification: this.state.notification};
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        return {
            get: false,
            submitType: "POST",
            title: "Enviar Notificación",
            buttonTitle: "Enviar Notificación",
            danger: false,
            warning: true,
            buttonIcon: "fa fa fa-send-o fa-lg",
            successMessage: "Se ha enviado la notificación.",
            saveButton: true,
            saveButtonLabel: "Actualizar",
            buttonClass: "btn-secondary",
            disabled: true,
            id: this.props.id,
        };
    }

    render() {
        let vars = this.modalVars();
        let submitUrl =
            api.gestion.ventas.vendedores.vendedorNotificacion;
        return (
            <ParadigmaModal
                getUrl={null}
                submitUrl={submitUrl}
                submitType={vars.submitType}
                id={vars.id}
                className="modal-lg"
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
            closeButton={true}
            >
           <Row>
            <Col>
                <ParadigmaLabeledInput
                    disabled={true}
                    md={[2,10]}
                    label={"Vendedor"}
                    value={this.props.row() ? this.props.row().Nombre : ''}
                    error={() => this.getError('username')}
                />
            </Col>
            </Row>
            <Col>
            <div className="mt-sm-1 row">
                <div className="col col-2 mx-auto my-2"><strong>Título</strong></div>
            </div>
            <div className="mt-sm-1 row">
                <Input
                    disabled={false}
                    type="text"
                    value={this.state.notification.title}
                    onChange={(e) => this.setState({ notification: {
                        title: e.target.value,
                        body: this.state.notification.body,
                    }})}
                />
            </div>

            <div className="mt-sm-1 row">
                <div className="col col-2 mx-auto my-2"><strong>Mensaje</strong></div>
            </div>
            </Col>
            <textarea className="c-input w-100 mt-2"rows={7}  width="max-content"
                value={this.state.notification.body}
                onChange={(e) => this.setState({ notification: {
                    title: this.state.notification.title,
                    body: e.target.value,
                }})}>
            </textarea>

        </ParadigmaModal>
        );
    }
}

export default Notificacion;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Vendedores/Notificacion.js